module.exports = __webpack_public_path__ + "static/img/zycp_chuangxin_a.ea7d573.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/test/zycp_chuangxin_a.jpg
// module id = c8em
// module chunks = 1